import React from 'react';
import {
    Col, FormGroup, Input, Label,
    Row
} from 'reactstrap';

import {LangController} from "../../../components/tabs/langController";

const UdnLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            slogan: '',
            schedule: '',
            address: '',
            description: '',
            included: '',
            recommendations: '',
            cancellationFee: '',
            image: '',
            note: '',
            shortDescription: '',
            servicesOnBoard: ''
        }) )
        setLangChilds(items);
    }

    const formAny = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="8">
                <FormGroup>
                    <Label>Nombre</Label>
                    <Input type="text"
                           name="name"
                           placeholder="Ingrese nombre"
                           disabled={disableInputs}
                           value={child.name}
                           onChange={ e => onInputChange(e, child.lang) }
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Imagen</Label>
                    <Input
                        type="text"
                        name="image"
                        placeholder="Imagen"
                        value={ child.image }
                        onChange={ e => onInputChange(e, child.lang) }
                        disabled={ disableInputs }
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Slogan</Label>
                    <Input type="textarea"
                           name="slogan"
                           rows="2"
                           placeholder="Ingrese slogan"
                           disabled={disableInputs}
                           value={child.slogan}
                           onChange={ e => onInputChange(e, child.lang) }
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Horarios de apertura</Label>
                    <Input type="text" name="schedule"
                           placeholder="Ingrese horarios"
                           value={child.schedule}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Dirección</Label>
                    <Input type="text" name="address"
                           placeholder="Ingrese dirección"
                           value={child.address}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Descripción</Label>
                    <Input type="textarea" rows="6" name="description"
                           placeholder="Ingrese descripción larga"
                           value={child.description}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >Recomendaciones</Label>
                    <Input type="textarea" rows="10" name="recommendations"
                           placeholder="Recomendaciones . . ."
                           value={child.recommendations}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >Incluye</Label>
                    <Input type="textarea" rows="10" name="included"
                           placeholder="Incluye . . "
                           value={child.included}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const formHotel = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="8">
                <FormGroup>
                    <Label>Slogan</Label>
                    <Input type="textarea"
                           name="slogan"
                           rows="1"
                           placeholder="Ingrese slogan"
                           disabled={disableInputs}
                           value={child.slogan}
                           onChange={(e) => onInputChange(e, child.lang)}
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Imagen</Label>
                    <Input
                        type="text"
                        name="image"
                        placeholder="Imagen"
                        value={ child.image }
                        onChange={ e => onInputChange(e, child.lang) }
                        disabled={ disableInputs }
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Dirección</Label>
                    <Input type="textarea" name="address"
                           placeholder="Ingrese dirección"
                           value={child.address}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Horarios de apertura</Label>
                    <Input type="text" name="schedule"
                           placeholder="Ingrese horarios"
                           value={child.schedule}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Descripción</Label>
                    <Input type="textarea" rows="5" name="description"
                           placeholder="Ingrese descripción larga"
                           value={child.description}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >Recomendaciones</Label>
                    <Input type="textarea" rows="10" name="recommendations"
                           placeholder="Recomendaciones . . ."
                           value={child.recommendations}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >Incluye</Label>
                    <Input type="textarea" rows="10" name="included"
                           placeholder="Incluye . . "
                           value={child.included}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const formEvents = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="8">
                <FormGroup>
                    <Label>Slogan</Label>
                    <Input type="textarea"
                           name="slogan"
                           rows="1"
                           placeholder="Ingrese slogan"
                           disabled={disableInputs}
                           value={child.slogan}
                           onChange={(e) => onInputChange(e, child.lang)}
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Imagen</Label>
                    <Input
                        type="text"
                        name="image"
                        placeholder="Imagen"
                        value={ child.image }
                        onChange={ e => onInputChange(e, child.lang) }
                        disabled={ disableInputs }
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Dirección</Label>
                    <Input type="textarea" name="address"
                           placeholder="Ingrese dirección"
                           rows="4"
                           value={child.address}
                           onChange={(e) => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const formPark = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label>Slogan</Label>
                    <Input type="textarea"
                           name="slogan"
                           rows="2"
                           placeholder="Ingrese slogan"
                           disabled={disableInputs}
                           value={child.slogan}
                           onChange={ e => onInputChange(e, child.lang) }
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Horarios de apertura</Label>
                    <Input type="text" name="schedule"
                           placeholder="Ingrese horarios"
                           value={child.schedule}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Descripción</Label>
                    <Input type="textarea" rows="5" name="description"
                           placeholder="Ingrese descripción larga"
                           value={child.description}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >Recomendaciones</Label>
                    <Input type="textarea" rows="10" name="recommendations"
                           placeholder="Recomendaciones . . ."
                           value={child.recommendations}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >Incluye</Label>
                    <Input type="textarea" rows="10" name="included"
                           placeholder="Incluye . . "
                           value={child.included}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Dirección</Label>
                    <Input type="text" name="address"
                           placeholder="Ingrese dirección"
                           value={child.address}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const formFerry = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="8">
                <FormGroup>
                    <Label>Nombre</Label>
                    <Input type="text"
                           name="name"
                           placeholder="Ingrese nombre"
                           disabled={disableInputs}
                           value={child.name}
                           onChange={ e => onInputChange(e, child.lang) }
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Imagen</Label>
                    <Input
                        type="text"
                        name="image"
                        placeholder="Imagen"
                        value={ child.image }
                        onChange={ e => onInputChange(e, child.lang) }
                        disabled={ disableInputs }
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Slogan</Label>
                    <Input type="textarea"
                           name="slogan"
                           rows="2"
                           placeholder="Ingrese slogan"
                           disabled={disableInputs}
                           value={child.slogan}
                           onChange={ e => onInputChange(e, child.lang) }
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Horarios de apertura</Label>
                    <Input type="text" name="schedule"
                           placeholder="Ingrese horarios"
                           value={child.schedule}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Descripción</Label>
                    <Input type="textarea" rows="5" name="description"
                           placeholder="Ingrese descripción larga"
                           value={child.description}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >Recomendaciones</Label>
                    <Input type="textarea" rows="10" name="recommendations"
                           placeholder="Recomendaciones . . ."
                           value={child.recommendations}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >Incluye</Label>
                    <Input type="textarea" rows="10" name="included"
                           placeholder="Incluye . . "
                           value={child.included}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>Dirección</Label>
                    <Input type="text" name="address"
                           placeholder="Ingrese dirección"
                           value={child.address}
                           onChange={ e => onInputChange(e, child.lang) }
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const getFormulary = (child, index, disableInputs, onInputChange) => {
        switch (props.appCode) {
            case "PARK" :
                return formPark(child, index, disableInputs, onInputChange)
            case "XKYNET" :
                return formPark(child, index, disableInputs, onInputChange)
            case "HCDP":
                return formHotel(child, index, disableInputs, onInputChange)
            case "HOTEL" :
                return formHotel(child, index, disableInputs, onInputChange)
            case "EVENTS" :
                return formEvents(child, index, disableInputs, onInputChange)
            case "FERRY" :
                return formFerry(child, index, disableInputs, onInputChange)
            default:
                return formAny(child, index, disableInputs, onInputChange)
        }
    }

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default UdnLangs
